import { radioCheckedIcon } from "assets/images";

const RadioCheckedBoxIcon = () => {
  return <img src={radioCheckedIcon} alt="checkbox" />;
};

export default RadioCheckedBoxIcon;
